import React from 'react';
import type { Locales } from 'cms/cms-types';
import { type ListingUILabel } from '3-components/ListingApp/ListingUI/ListingUI';

export type AppStatus = 'initial-loading' | 'fetching' | 'initial-error' | 'error' | 'ready';

export interface EventCalendarLabel extends ListingUILabel {
    title: string;
    clearFilterButton: string;
    minReadSuffix: string;
}

export interface EventCalendarCMSConfig {
    apiUrl: string;
    apiKey: string;
    siteId: string;
}

type FilterItem = {
    id: number;
    name: string;
    description: string;
}

// Simplified filter structure for Event Calendar
export interface SimpleFilter {
    name: string;
    values: FilterItem[];
    activeDefaultValues: FilterItem[];
    isCustomFilter: boolean;
    hideFilter: boolean;
}

export interface EventCalendarProps {
    locale?: Locales;
    cms: EventCalendarCMSConfig;
    filters?: SimpleFilter[];
    hideFilters?: boolean;
    dataTypes?: string[];
    experienceBrands?: string[];
}

export type EventCalendarContextProps = EventCalendarProps;

const EventCalendarContext = React.createContext<Partial<EventCalendarContextProps>>({});

export default EventCalendarContext;
